module.exports = __webpack_public_path__ + "static/index/img/baikal-400.074e5fef.jpg";